import { Bold, Italic, RemoveFormatting, Strikethrough, Subscript, Superscript, Type, Underline } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ToolbarButton, ToolbarGroup } from '../../ui/ToolbarButton';
import { ToolbarMenu } from '../../ui/ToolbarMenu';
import { useBlockActions } from './useBlockActions';
import type { ToolbarState } from './useToolbarState';

/** Bold / italic / underline, plus the "⋮" popup with strikethrough, sub/superscript and clear formatting. */
export const TextFormatGroup = ({ state, disabled }: { state: ToolbarState; disabled: boolean }) => {
  const { t } = useTranslation('common');
  const { format, clearFormatting } = useBlockActions(state.blockType);

  return (
    <ToolbarGroup>
      <ToolbarButton icon={Bold} label={t('editor.toolbar.bold')} active={state.bold} disabled={disabled} onClick={() => format('bold')} />
      <ToolbarButton icon={Italic} label={t('editor.toolbar.italic')} active={state.italic} disabled={disabled} onClick={() => format('italic')} />
      <ToolbarButton
        icon={Underline}
        label={t('editor.toolbar.underline')}
        active={state.underline}
        disabled={disabled}
        onClick={() => format('underline')}
      />
      <ToolbarMenu
        icon={Type}
        caret="more"
        layout="row"
        label={t('editor.toolbar.more-text')}
        // Lit while a hidden format is on, so it can be found without opening the popup
        active={state.strikethrough || state.subscript || state.superscript}
        disabled={disabled}
      >
        {() => (
          <>
            <ToolbarButton
              icon={Strikethrough}
              label={t('editor.toolbar.strikethrough')}
              active={state.strikethrough}
              onClick={() => format('strikethrough')}
            />
            <ToolbarButton icon={Subscript} label={t('editor.toolbar.subscript')} active={state.subscript} onClick={() => format('subscript')} />
            <ToolbarButton
              icon={Superscript}
              label={t('editor.toolbar.superscript')}
              active={state.superscript}
              onClick={() => format('superscript')}
            />
            <ToolbarButton icon={RemoveFormatting} label={t('editor.toolbar.clear-formatting')} onClick={clearFormatting} />
          </>
        )}
      </ToolbarMenu>
    </ToolbarGroup>
  );
};
